import { render } from "./ProductSectionListComponent.vue?vue&type=template&id=10215abc&scoped=true"
import script from "./ProductSectionListComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionListComponent.vue?vue&type=script&lang=js"

import "./ProductSectionListComponent.vue?vue&type=style&index=0&id=10215abc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10215abc"],['__file',"resources/js/components/admin/productSections/ProductSectionListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10215abc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10215abc', __exports__)) {
    api.reload('10215abc', __exports__)
  }
  
  module.hot.accept("./ProductSectionListComponent.vue?vue&type=template&id=10215abc&scoped=true", () => {
    api.rerender('10215abc', render)
  })

}


export default __exports__